import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttachableInterface, AttachableRequestModel, CategoryFileTypeModel, GenericResModel } from 'countable@model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DownloadAttachableInterface } from '../model/tb/attachable/download-attachable.interface';
import { EngAttachableInterface } from '../model/tb/attachable/eng-attachable.interface';

@Injectable({
  providedIn: 'root'
})
export class SourceAttachableService {

  private static readonly ATTACHABLE_CATEGORIES = environment.apiV2 + '/eng/attachable/category';
  private static readonly ATTACHABLE_ALL = environment.apiV2 + '/eng/attachable/all';
  private static readonly ATTACHABLE = environment.apiV2 + '/eng/attachable';
  private static readonly ATTACHABLE_SAVE = environment.apiV2 + '/eng/attachable/save';
  private static readonly ATTACHABLE_DOWNLOAD_FILE = environment.apiV2 + '/eng/attachable/download-file';
  private static readonly ATTACHABLE_DOWNLOAD = environment.apiV2 + '/eng/attachable/download';

  constructor(private http: HttpClient) { }

  public fetchAttachableCategoryAndTypes(engId: number): Observable<GenericResModel<CategoryFileTypeModel>> {
    return this.http.get<GenericResModel<CategoryFileTypeModel>>(`${SourceAttachableService.ATTACHABLE_CATEGORIES}/${engId}`);
  }

  public fetchSelectedAttachable(input: AttachableRequestModel): Observable<GenericResModel<AttachableInterface[]>> {
    return this.http.post<GenericResModel<AttachableInterface[]>>(SourceAttachableService.ATTACHABLE_ALL, input);
  }

  public fetchAttachableById(id: string, engId: number) {
    return this.http.get(`${SourceAttachableService.ATTACHABLE}/${id}/${engId}`, {responseType: 'blob'});
  }

  public saveAttachableByIds(input: EngAttachableInterface): Observable<GenericResModel<any>> {
    return this.http.post<GenericResModel<any>>(SourceAttachableService.ATTACHABLE_SAVE, input);
  }

  public downloadAttachableByIds(input: EngAttachableInterface): Observable<any> {
    return this.http.post<any>(SourceAttachableService.ATTACHABLE_DOWNLOAD, input, {responseType: 'blob' as 'json'});
  }

  public downloadAttachableByFileIds(input: DownloadAttachableInterface): Observable<string> {
    return this.http.post(SourceAttachableService.ATTACHABLE_DOWNLOAD_FILE, input, {
      responseType: 'text'
    });
  }
}
